/*
 *******************************************************************************
 *
 *  Filename:   /redux/slices/companies.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Companies redux reducer
 *
 *  Author:     Norman J. Nolasco [ Archetact Software ]
 *
 *  Created:    Tuesday, January 02, 2024 - 4:47 AM (CST)
 *
 *  Notes:
 *
 *  Revisions:
 *              2024/01/02  NJN Initial Build
 *
 *  Copyright (c) 2024 - Archetact Software - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyid: 0,
  parentid: 0,
  companystatusid: 0,
  companystatus: "",
  page: "",
  error: null,
  defaultToolPanel: "",
  companyorder: "NAME ASC",
  search: "",
  columnState: [],
};

const intFields = ["companyid", "parentid", "companystatusid"];

const updateFieldReducer = (state, action, field) => {
  const value = action.payload ? action.payload[field] : undefined;

  if (value !== undefined) {
    state[field] = intFields.includes(field) ? parseInt(value, 10) : value;
    state.error = Number.isNaN(state[field]) ? `Invalid value for ${field}.` : null;
  } else {
    state.error = `No ${field} provided.`;
  }
};

export const companySlice = createSlice({
  name: "companies",
  initialState,
  reducers: {
    updateCompanyID: (state, action) => updateFieldReducer(state, action, "companyid"),
    updateParentID: (state, action) => updateFieldReducer(state, action, "parentid"),
    updateCompanyStatusID: (state, action) => updateFieldReducer(state, action, "companystatusid"),
    updateCompanyStatus: (state, action) => updateFieldReducer(state, action, "companystatus"),
    updatePage: (state, action) => updateFieldReducer(state, action, "page"),
    updateDefaultToolPanel: (state, action) => updateFieldReducer(state, action, "defaultToolPanel"),
    updateColumnState: (state, action) => updateFieldReducer(state, action, "columnState"),
  },
});

export const {
  updateParentID,
  updateCompanyStatusID,
  updateCompanyStatus,
  updatePage,
  updateDefaultToolPanel,
  updateColumnState,
} = companySlice.actions;

export default companySlice.reducer;
